import { Fab } from "@mui/material";
import NotFound from "components/not-found/NotFound";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "components/Button/Button";
import DeleteIcon from "@mui/icons-material/Delete";

import { dateFormat } from "utils";
import CustomTooltip from "components/Tooltip/CustomTooltip";
import {
  deleteDailyQuiz,
  getDailyQuizs,
} from "services/dailyQuiz/dailyQuizController";
import useDataTable from "hooks/useDataTable";
import SpeedDial from "components/speed-dial/SpeedDial";
import ModalBox from "components/modal/ModalBox";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { Table } from "react-bootstrap";
import Link from "components/Button/Link";
import IconButton from "components/Button/IconButton";

const ViewQuizs = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;

  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  const { TableHead, TableBody, selectedId, setSelectedId } = useDataTable(
    record,
    "id"
  );

  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  //**********quiz Listing**********/
  const quizListing = async (page = activePage, search = debounceValue) => {
    try {
      showLoader();
      const res = await getDailyQuizs({
        page,
        search,
      });
      hideLoader();
      if (res.code === 200) {
        const { dailyQuiz, count } = res.data;
        setRecord(dailyQuiz || []);
        setTotal(count || 0);
        setSelectedId([]);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  //********Reset Filter****** */
  const restFilter = () => {
    setSearch("");
  };

  // delete quiz function
  const deleteQuizHandler = async () => {
    if (selectedId.length > 0) {
      try {
        setSubmitLoading(true);
        const res = await deleteDailyQuiz({
          quizIds: selectedId,
        });
        if (res.code === 200) {
          quizListing();
          toast.success(res.message);
          setDeleteModal(false);
          setSubmitLoading(false);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    quizListing(activePage, debounceValue, "");
    // eslint-disable-next-line
  }, [searchParam, debounceValue]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
    // eslint-disable-next-line
  }, [search]);

  return (
    <React.Fragment>
      <title>Shubhra Viraj | Daily Quiz Management</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="SearchBox">
                <div className="div_wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    name="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="div_no_wrap mx-3"></div>

                <Button className="refresh_btnn mx-2" onClick={restFilter}>
                  <i className="fa fa-refresh"></i>
                </Button>
                <div>
                  <Button to="add" type="acl" role={190001}>
                    Add Quiz
                  </Button>
                </div>
              </div>
              <h4 className="Title">Daily Quiz</h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>
                      <TableHead type="acl" role={190004} />
                    </th>
                    <th>S.No</th>
                    <th>Quiz Date</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(({ id, quizDate, createdAt }, i) => (
                      <tr key={i}>
                        <td>
                          <TableBody id={id} type="acl" role={190004} />
                        </td>
                        <td>{++i + (activePage - 1) * 10}</td>
                        <td>
                          <div className="">
                            <CustomTooltip length={15}>
                              {dateFormat(quizDate)}
                            </CustomTooltip>
                          </div>
                        </td>
                        <td>
                          <div className="">
                            <CustomTooltip length={15}>
                              {dateFormat(createdAt)}
                            </CustomTooltip>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex justify-content-center">
                            <Link
                              to={`update/${id}`}
                              className="m-0"
                              type="acl"
                              role={190002}
                            >
                              <IconButton
                                aria-label="view"
                                className="px-2 py-0"
                              >
                                <EditIcon sx={{ color: "#4971B2" }} />
                              </IconButton>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* delete model */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title={"Delete Quiz"}
        description={"Are you sure want to delete this quiz ?"}
        customizedFooter={
          <Button onClick={deleteQuizHandler} {...submitButtonElement}>
            Yes
          </Button>
        }
      />

      {/* multi delete speed dial button */}
      {selectedId.length > 0 && (
        <SpeedDial>
          <Fab
            size="medium"
            color="primary"
            aria-label="add"
            onClick={() => setDeleteModal(true)}
            sx={{ position: "absolute", bottom: 16, right: 16 }}
          >
            <DeleteIcon />
          </Fab>
        </SpeedDial>
      )}
    </React.Fragment>
  );
};

export default ViewQuizs;
